(function () {
  const form = document.getElementById('ContactForm');
  if (!form) return;

  // Errors are rendered entirely by this script (see updateSummary/setFieldError
  // below), so the browser's own validation bubbles - inconsistent across mobile
  // browsers, which is why the form previously appeared to show nothing on submit -
  // are turned off in favor of that single consistent path.
  form.setAttribute('novalidate', 'novalidate');

  const summary = document.getElementById('ContactForm-error-summary');
  const summaryHeading = document.getElementById('ContactForm-error-heading');
  const summaryList = document.getElementById('ContactForm-error-summary-list');
  const submitButton = document.getElementById('ContactForm-submit');

  const fields = [
    {
      input: document.getElementById('ContactForm-name'),
      wrapper: document.getElementById('ContactForm-name-field'),
      error: document.getElementById('ContactForm-name-error'),
      label: 'Name',
      requiredMessage: 'Name is required',
    },
    {
      input: document.getElementById('ContactForm-email'),
      wrapper: document.getElementById('ContactForm-email-field'),
      error: document.getElementById('ContactForm-email-error'),
      label: 'Email',
      requiredMessage: 'Email is required',
      invalidMessage: 'Email is invalid',
    },
    {
      input: document.getElementById('ContactForm-body'),
      wrapper: document.getElementById('ContactForm-body-field'),
      error: document.getElementById('ContactForm-body-error'),
      label: 'Comment',
      requiredMessage: 'Comment is required',
    },
  ].filter((field) => field.input && field.wrapper && field.error);

  function fieldErrorText(field) {
    const textEl = field.error.querySelector('.contact__field-error-text');
    return textEl ? textEl.textContent.trim() : '';
  }

  function setFieldError(field, message) {
    const textEl = field.error.querySelector('.contact__field-error-text');
    if (textEl) textEl.textContent = message;
    field.error.hidden = false;
    field.wrapper.classList.add('field--with-error');
    field.input.setAttribute('aria-invalid', 'true');
    field.input.setAttribute('aria-describedby', field.error.id);
  }

  function clearFieldError(field) {
    field.error.hidden = true;
    field.wrapper.classList.remove('field--with-error');
    field.input.removeAttribute('aria-invalid');
    field.input.removeAttribute('aria-describedby');
  }

  function validateField(field) {
    const value = field.input.value.trim();

    if (field.input.hasAttribute('required') && value === '') {
      setFieldError(field, field.requiredMessage);
      return false;
    }

    if (field.input.type === 'email' && value !== '' && !field.input.checkValidity()) {
      setFieldError(field, field.invalidMessage || 'Email is invalid');
      return false;
    }

    clearFieldError(field);
    return true;
  }

  // Re-validate as the visitor fixes a field, so the summary/inline error clears
  // immediately rather than only on the next submit attempt.
  fields.forEach((field) => {
    field.input.addEventListener('input', () => {
      if (validateField(field) && summary && !summary.hidden) {
        updateSummary(fields.filter((f) => f.error && !f.error.hidden));
      }
    });
    field.input.addEventListener('blur', () => validateField(field));
  });

  function updateSummary(invalidFields) {
    if (!summary || !summaryList) return;

    summaryList.innerHTML = '';

    if (invalidFields.length === 0) {
      summary.hidden = true;
      return;
    }

    invalidFields.forEach((field) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + field.input.id;
      a.className = 'link';
      a.textContent = field.label + ' ' + fieldErrorText(field);
      a.addEventListener('click', (event) => {
        event.preventDefault();
        field.input.focus();
      });
      li.appendChild(a);
      summaryList.appendChild(li);
    });

    summary.hidden = false;
  }

  function setSubmitting(isSubmitting) {
    if (!submitButton) return;
    submitButton.disabled = isSubmitting;
    submitButton.classList.toggle('loading', isSubmitting);
    const spinner = submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isSubmitting);
  }

  form.addEventListener('submit', (event) => {
    const invalidFields = fields.filter((field) => !validateField(field));

    if (invalidFields.length > 0) {
      event.preventDefault();
      updateSummary(invalidFields);
      if (summaryHeading) summaryHeading.focus();
      summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    updateSummary([]);
    setSubmitting(true);
  });
})();
